import React from "react"
import styles from '../../styles/apuracao.module.css'

interface iProps {
    feriados: any[]
}

export default function ApuracaoPagePainelDetalhesFeriado({feriados}:iProps) {
    const divStyle:React.CSSProperties = {
        margin: "10px 0px",
    }
    
    return (
        <div style={divStyle}>
            {
                feriados.map((registro:any, index:any) => (
                    <div key={index} className={styles.apuracaoDiaRegs} style={divStyle}>
                        <p>Feriado: {registro.descricao}</p>
                    </div>
                ))
            }
        </div>
    )
}
